var _path, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShoppingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 65,
    viewBox: "0 0 54 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.358 29.3784V25.3784C23.358 23.1684 25.153 21.3784 27.358 21.3784C29.568 21.3784 31.358 23.1734 31.358 25.3784V29.3784M19.358 27.3784H35.358V43.3784H19.358V27.3784Z",
    stroke: "url(#paint0_radial_189:169)",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.13068,
    y: 0.990662,
    width: 52.4547,
    height: 62.7759,
    rx: 4.75,
    stroke: "url(#paint1_radial_189:169)",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_189:169",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.358 42.4078) rotate(-70.467) scale(28.1494 22.5106)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D74E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ACEC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_189:169",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.1194 61.2249) rotate(-67.7929) scale(82.4166 73.1884)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D74E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ACEC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingIcon);
export default __webpack_public_path__ + "static/media/shopping_icon.82cdd1c3.svg";
export { ForwardRef as ReactComponent };